import { Component } from 'react';
import PropTypes from 'prop-types';

import './YearInput.css';

import { getStyleValue, isValidYear } from '../Helpers/Helpers';

import { Button } from '@mui/material';

class YearInput extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value || '',
			defaultValue: props.defaultValue || this.props.t.year,
			selected: false,
			hideInput: true,
			validYear: props.value ? isValidYear(props.value) : true,
		};
	}
	onFocus() {
		this.setState({
			hideInput: false,
			selected: true,
			value: '',
		}, () => {
			this.input.focus();
		});
	}
	onBlur(event) {
		let value = event.target.value || this.props.value;
		if (!event.target.value) {
			if (isValidYear(this.props.value)) {
				value = this.props.value;
			} else {
				value = '';
			}
		}
		this.setState({
			hideInput: true,
			selected: false,
			value,
		});
		this.setIsValid(value);
	}
	onChange(event) {
		let value = event.target.value;
		if (value.length <= 4) {
			this.setState({ value });
		}
	}
	setIsValid(value) {
		const validYear = value
			? isValidYear(value)
			: true; // If no value is set, consider valid because it is not a required field
		this.setState({ validYear });
	}
	getBackgroundColor() {
		if (this.state.selected) {
			return getStyleValue('color-grey');
		} else if (!this.state.validYear) {
			return getStyleValue('color-red');
		} else if(this.state.value) {
			return getStyleValue('color-primary');
		}
		return getStyleValue('color-grey');
	}


	render() {
		const labelColor = () => {
			let color = 'rgba(0,0,0,.01)';

			if (this.state.hideInput) {
				if (this.state.value) {
					color = getStyleValue('color-white');
				} else {
					color = getStyleValue('color-text');
				}
			}

			return color;
		};

		const { ...filteredProps } = this.props; // eslint-disable-line no-unused-vars

		return (
			<div style={{ marginTop: getStyleValue('spacing-half') }} {...filteredProps}>
				<div className="year-input">
					<Button
						variant="contained"
						className="button-input"
						style={{
							backgroundColor: this.getBackgroundColor(),
							color: labelColor(),
						}}
						onFocus={this.onFocus.bind(this)}>
						{this.state.value || this.state.defaultValue}
					</Button>

					<input name={this.props.name}
						type="number"
						value={this.state.value}
						ref={(input) => { this.input = input; }}
						hidden={this.state.hideInput}
						data-notrequired={this.props['data-notrequired']}
						data-isvalid={this.state.validYear}
						style={{
							color: (!this.state.selected && !!this.state.value) ? getStyleValue('color-white') : getStyleValue('color-text'),
						}}
						onChange={this.onChange.bind(this)}
						onBlur={this.onBlur.bind(this)}
					/>
				</div>
			</div>
		);
	}
}

YearInput.propTypes = {
	value: PropTypes.string,
	name: PropTypes.string.isRequired,
};

export default YearInput;
